import { __assign, __rest } from "tslib";
import React from 'react';
import cx from 'classnames';
import { Dropdown as RODropdown } from 'react-overlays';
var MOBILE_BREAKPOINT = 576;
export var DropdownMenu = function (props) {
    var children = props.children, className = props.className, _a = props.autoPosition, autoPosition = _a === void 0 ? true : _a, menuProps = __rest(props, ["children", "className", "autoPosition"]);
    var width = window.innerWidth;
    return (React.createElement(RODropdown.Menu, { flip: true, offset: [0, 5], popperConfig: width < MOBILE_BREAKPOINT && !autoPosition
            ? {
                modifiers: [
                    {
                        name: 'computeStyles',
                        enabled: true,
                        fn: function (_a) {
                            var state = _a.state;
                            return __assign(__assign({}, state), { styles: __assign(__assign({}, state.styles), { popper: {} }) });
                        },
                    },
                ],
            }
            : undefined }, function (props, _a) {
        var show = _a.show;
        return (React.createElement("ul", __assign({ className: cx('dropdown-menu', show ? 'd-block' : 'd-none', className) }, props, menuProps), children));
    }));
};
//# sourceMappingURL=DropdownMenu.js.map